import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const PlaceholderContainer = styled.div`
	display: flex;
	width: 100%;
	max-width: 1170px;
	height: auto;
	min-height: 50vh;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
	gap: var(--gap-x10);
	grid-column: 1 / -1;

	${MqTablet} {
		min-height: 60vh;
	}
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--gap-x6);
`;
